export enum Environment {
  dev = 'dev',
  qa = 'qa',
  staging = 'staging',
  'pre-production' = 'pre-production',
  production = 'production',
}

export const getIdentityBaseUrl = (env: Environment) => {
  switch (env) {
    case Environment.dev:
    case Environment.qa:
    case Environment.staging:
      return 'https://identity-staging.sitecore-staging.cloud/api/identity/v1';
    case Environment['pre-production']:
      return 'https://identity-beta.sitecorecloud.io/api/identity/v1';
    case Environment.production:
      return 'https://identity.sitecorecloud.io/api/identity/v1';
    default:
      if (process.env.NODE_ENV !== 'test') {
        throw new Error('Unexpected environment value.');
      }

      return '';
  }
};

export function getInventoryBaseUrl(env: Environment) {
  switch (env) {
    case Environment.dev:
    case Environment.qa:
    case Environment.staging:
      return 'https://platform-inventory-staging.sitecore-staging.cloud/api/inventory/v1';
    case Environment['pre-production']:
      return 'https://platform-inventory-beta.sitecorecloud.io/api/inventory/v1';
    case Environment.production:
      return 'https://platform-inventory.sitecorecloud.io/api/inventory/v1';
    default:
      if (process.env.NODE_ENV !== 'test') {
        throw new Error('Unexpected environment value.');
      }
      return '';
  }
}

export const getPortalUrl = (env: string) => {
  switch (env) {
    case 'dev':
      return 'https://portal-dev.sitecore-staging.cloud/';
    case 'qa':
      return 'https://portal-qa.sitecore-staging.cloud/';
    case 'staging':
      return 'https://portal-staging.sitecore-staging.cloud/';
    case 'pre-production':
      return 'https://portal-beta.sitecorecloud.io/';
    case 'production':
      return 'https://portal.sitecorecloud.io/';
    default:
      return '';
  }
};

export const getPortalApiBaseUrl = (env: string) => {
  switch (env) {
    case Environment.dev:
    case Environment.qa:
    case Environment.staging:
      return 'https://portal-api-staging.sitecore-staging.cloud/';
    case Environment['pre-production']:
    case 'preprod':
      return 'https://portal-api-preprod.sitecorecloud.io/';
    case Environment.production:
    case 'prod':
      return 'https://portal-api.sitecorecloud.io/';
    default:
      return '';
  }
};
